import { FC } from 'react';

import { Button, Text } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { PromoCodeModal } from 'components/Admin/PromoCodes/PromoCodeModal/PromoCodeModal';

import styles from 'components/Admin/PromoCodes/PromoCodesTitle/PromoCodesTitle.module.less';

const TrlKeys = {
    title: 'admin.promoCodes.title',
    button: 'admin.promoCodes.button',
};

export const PromoCodesTitle: FC = () => {
    const trl = useTrls();
    const [isModalVisible, setIsModalVisibleOn, setIsModalVisibleOff] = useOnOffState(false);

    return (
        <div className={styles.header}>
            <Text typography="title-2-semibold" style="primary">
                {trl(TrlKeys.title)}
            </Text>
            <Button mode="primary" style="accent" onClick={setIsModalVisibleOn}>
                {trl(TrlKeys.button)}
            </Button>
            <PromoCodeModal visible={isModalVisible} onClose={setIsModalVisibleOff} />
        </div>
    );
};
